import React from "react";
import { Toast, ToastBody, ToastHeader } from "reactstrap";
import { Image, P } from "../../../../AbstractElements";
import { ToastPlacementContentProp } from "../../../../Types/BonusUiType";
import { dynamicImage } from "../../../../Utils";

const ToastPlacementContent: React.FC<ToastPlacementContentProp> = ({ selectedPosition }) => {
  return (
    <div className="bg-light position-relative bd-example-toasts">
      <div className={`toast-container p-3 position-absolute ${selectedPosition}`} id="toastPlacement">
        <Toast fade>
          <ToastHeader className="toast-img">
            <Image className="rounded me-2" src={dynamicImage(`profile.png`)} alt="profile" />
            <strong className="me-auto">{"Moscow Theme"}</strong>
            <small className="d-sm-block d-none">{"25 min ago"}</small>
          </ToastHeader>
          <ToastBody className="toast-dark txt-dark">
            <P className="toast-content">
              <em className="txt-danger">{"Attackers"}</em>
              {" on malicious activity may trick you into doing something dangrous like installing software or revealing your personal informations."}
            </P>
          </ToastBody>
        </Toast>
      </div>
    </div>
  );
};
export default ToastPlacementContent;
